/** ID generation and the notification-ID naming convention. */

export function newId(): string {
  return crypto.randomUUID();
}

/**
 * Notification IDs are semantic content identifiers, not opaque randoms:
 * `<category>.<subject>.<variant>`, e.g. `weather.reykjavik.current`,
 * `nothing.generic.047`, `time.ulaanbaatar.012`.
 */
const NOTIFICATION_ID_PATTERN = /^[a-z_]+\.[a-z0-9_]+\.[a-z0-9_]+$/;

export function isValidNotificationId(id: string): boolean {
  return NOTIFICATION_ID_PATTERN.test(id);
}

export function buildNotificationId(category: string, subject: string, variant: string | number): string {
  const id = `${category}.${subject}.${variant}`;
  if (!isValidNotificationId(id)) {
    throw new Error(`Generated notification id fails naming convention: "${id}"`);
  }
  return id;
}
